import { gql } from '@apollo/client/core';
import { DistributionContacts, ProducerDescription, ProducerLogo } from '.';

const producerFragment = gql`
  fragment Producer on RegisteredBrand {
    ...DistributionContacts
    # profile {
    #   # ...ProducerDescription # This is invalid here
    #   # ...ProducerLogo # This is invalid here
    # }
  }
  ${DistributionContacts.fragment}
  # $ {ProducerDescription.fragment}
  # $ {ProducerLogo.fragment}
`;

export default producerFragment;
